/**
 *
 * 解决h5下微信环境和支付宝环境下标题不更新的问题
 *
 * @param {string} title
 */
export const setDocumentTitle = function (title) {
  const titleEle = document.getElementsByTagName('title') && document.getElementsByTagName('title')[0]
  if (titleEle && titleEle.innerHTML) {
    titleEle.innerHTML = title
  }
}
